<template>
  <v-container fluid id="benefits-page">
    <img id="orb-1" :src="require(`../assets/orb-3.svg`)" alt="Orb 1" />
    <img id="splash" :src="require(`../assets/splash.png`)" alt="splash" />
    <img id="circle" :src="require(`../assets/circle.png`)" alt="circle" />
    <img
      id="circle-1"
      :src="require(`../assets/circle-1.png`)"
      alt="circle-1"
    />
    <img
      id="donut-cat"
      :src="require(`../assets/donut-cat.png`)"
      alt="donut cat"
    />
    <v-row id="content" class="ml-16 mt-5">
      <v-col sm="11" md="7" lg="5">
        <h1 id="title">Benefits & utilities</h1>
        <p id="paragraph" class="mt-12">
          When you buy a Kitty, you don’t buy only an avatar or a piece of art.
          You are gaining membership access to a club whose benefits and
          offerings will increase over time. Your Shiba can serve as your
          digital identity, and open digital doors for you.
        </p>
        <p id="paragraph" class="mt-12 mb-16">
          Entering into the Kitty Club Community means joining a family full of
          investors and nft enthusiasts who believe in the future of
          Cryptocurrencies and the blockchain technology.
        </p>
        <a href="#" class="glow-button"
          ><v-icon large color="#FFFFFF" class="mr-2">mdi-discord</v-icon>Join
          our discord</a
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Benefits",

  data: () => ({}),
};
</script>
<style scoped>
.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 15px 40px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  font-size: 25px !important;
  cursor: pointer;
  z-index: 2;
}
#title {
  color: white !important;
  font-weight: 500 !important;
  font-size: 5vw !important;
  line-height: 5vw !important;
  z-index: 1;
}
#paragraph {
  color: white !important;
  font-weight: 300 !important;
  font-size: 1.2vw !important;
  line-height: 1.6vw !important;
  z-index: 1;
}
#benefits-page {
  color: white;
  height: calc(100vh - 80px);
  background: #000000;
  position: relative;
  overflow: hidden;
}
#orb-1 {
  position: absolute;
  top: -20%;
  left: -15%;
  z-index: 0;
  opacity: 0.8;
}
#donut-cat {
  position: absolute;
  right: 10vw;
  top: 10vh;
  z-index: 0 !important;
  width: 30vw;
}

#splash {
  position: absolute;
  right: 0;
  margin-top: 5vh;
  z-index: 0 !important;
  height: 80vh;
}

#circle {
  position: absolute;
  right: -20vh;
  margin-top: 10vh;
  z-index: 0 !important;
  height: 70vh;
}
#circle-1 {
  position: absolute;
  right: 25vw;
  z-index: 0 !important;
  height: 40vh;
}

@media screen and (max-width: 961px) {
  #content {
    margin-top: 0 !important;
  }
  #benefits-page {
    height: calc(100vh - 56px);
    margin-top: 0px !important;
  }
  #paragraph {
    font-size: 2vw !important;
    line-height: 2vw !important;
  }
  #donut-cat {
    right: 20vw;
    width: 50vw;
    top: 55vh;
  }
  #splash {
    height: 50vh;
    top: 40vh;
  }
  #circle {
    right: -10vw;
    height: 40vh;
    top: 40vh;
  }

  #circle-1 {
    right: 40vw;
    height: 20vh;
    top: 50vh;
  }
}
@media screen and (max-width: 821px) {
  #content {
    margin-left: 25px !important;
  }
  #title {
    font-size: 8vw !important;
    line-height: 9vw !important;
    margin-top: 50px;
  }

  #paragraph {
    font-size: 3vw !important;
    line-height: 3.5vw !important;
  }

  .glow-button {
    font-size: 4vw !important;
  }
  #donut-cat {
    right: 20vw;
    width: 40vw;
    top: 60vh;
  }
  #splash {
    height: 40vh;
    top: 50vh;
  }
  #circle {
    right: -20vw;
    height: 40vh;
    top: 50vh;
  }

  #circle-1 {
    right: 40vw;
    height: 20vh;
    top: 55vh;
  }
}
@media screen and (max-width: 600px) {
  #content {
    margin-left: 12px !important;
  }
  #title {
    margin-top: 20px;
  }
  #paragraph {
    margin-top: 30px !important;
  }
}
@media screen and (max-width: 426px) {
  #donut-cat {
    right: 20vw;
    width: 50vw;
    top: 65vh;
  }
  #splash {
    height: 35vh;
    top: 55vh;
  }
  #circle {
    right: -10vw;
    height: 30vh;
    top: 55vh;
  }
  #circle-1 {
    right: 45vw;
    height: 15vh;
    top: 57vh;
  }
  #paragraph {
    font-size: 4.5vw !important;
    line-height: 5vw !important;
  }
}
@media screen and (max-width: 376px) {
  #paragraph {
    font-size: 3vw !important;
    line-height: 3vw !important;
  }
  #title {
    font-size: 8vw !important;
    line-height: 8vw !important;
  }
  #donut-cat {
    display: none;
  }
  #splash {
    display: none;
  }
  #circle {
    display: none;
  }
  #circle-1 {
    display: none;
  }
  #paragraph {
    font-size: 4.5vw !important;
    line-height: 5vw !important;
  }
}
</style>
